<template>
  <section class="alert-panel">
    <div class="alert-summary">
      <div class="summary-card summary-card--fault">
        <div class="summary-count">{{ alertState.faultCount }}</div>
        <div class="summary-label">故障预警</div>
      </div>
      <div class="summary-card summary-card--maintenance">
        <div class="summary-count">{{ alertState.maintenanceCount }}</div>
        <div class="summary-label">保养预警</div>
      </div>
    </div>

    <div class="alert-list">
      <div v-for="alert in alertState.alerts" :key="alert.id" class="alert-row">
        <span>{{ alert.name }}</span>
        <span :class="['alert-icon', `alert-icon--${alert.type}`]"></span>
      </div>
    </div>
  </section>
</template>

<script>
import { parseAlerts } from "../../utils/protocol/alerts";

export default {
  name: "AlertPanel",
  props: {
    protocol: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    alertState() {
      return parseAlerts(this.protocol);
    }
  }
};
</script>

<style lang="scss" scoped>
.alert-summary {
  position: absolute;
  top: 534px;
  left: 1538px;
  display: flex;
}

.summary-card {
  width: 156px;
  height: 60px;
  color: #fff;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  font-size: 12px;
  font-weight: 500;
  text-align: center;
}

.summary-card + .summary-card { margin-left: 28px; }
.summary-card--fault { background-image: url("/images/dashboard/gzyj.png"); }
.summary-card--maintenance { background-image: url("/images/dashboard/byyj.png"); }

.summary-count {
  margin-top: 0;
  transform: translateY(-15px);
  background-image: -webkit-linear-gradient(bottom, #ff0000, #ffffff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 36px;
  font-weight: 500;
}

.summary-card--maintenance .summary-count {
  background-image: -webkit-linear-gradient(bottom, #fab025, #ffffff);
}

.summary-label { transform: translate(15px, -10px); }

.alert-list {
  position: absolute;
  top: 616px;
  left: 1525px;
  width: 366px;
  height: 430px;
  overflow-x: hidden;
  overflow-y: auto;
  box-sizing: border-box;
  scrollbar-color: rgba(63, 175, 255, 0.85) rgba(5, 17, 30, 0.6);
  scrollbar-width: auto;
}

.alert-list::-webkit-scrollbar { width: 12px; }
.alert-list::-webkit-scrollbar-track { background: rgba(5, 17, 30, 0.6); border-radius: 4px; }
.alert-list::-webkit-scrollbar-thumb {
  border: 2px solid rgba(5, 17, 30, 0.9);
  border-radius: 6px;
  background: linear-gradient(180deg, rgba(63, 175, 255, 0.95), rgba(0, 149, 255, 0.45));
  box-shadow: 0 0 6px rgba(63, 175, 255, 0.45);
}

.alert-row {
  display: flex;
  height: 44px;
  padding: 0 23px;
  align-items: center;
  justify-content: space-between;
  background: #020406;
  color: #fff;
  font-size: 16px;
  font-weight: 400;
}

.alert-row:nth-child(odd) { background: #05111e; }

.alert-icon {
  width: 24px;
  height: 24px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
}

.alert-icon--normal { background-image: url("/images/dashboard/lgzicon.png"); }
.alert-icon--maintenance { background-image: url("/images/dashboard/ygzicon.png"); }
.alert-icon--fault { background-image: url("/images/dashboard/rgzicon.png"); }
</style>
